import axios from 'axios';
import maintenanceService from './maintenanceService';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        if (maintenanceService.isInMaintenance) {
            const currentMessage = maintenanceService.isInMaintenance
                ? maintenanceService.maintenanceMessageActive
                : maintenanceService.maintenanceMessage;
            const error = new Error(currentMessage);
            error.isMaintenance = true;
            error.status = 503;
            return Promise.reject(error);
        }

        const authToken = localStorage.getItem('authToken');
        if (authToken && authToken !== 'token') {
            config.headers.Authorization = `Bearer ${authToken}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

api.interceptors.response.use(
    (response) => {
        const isOurApi =
            response.config.url &&
            (response.config.url.includes('/cpanel/') ||
                response.config.url.includes(import.meta.env.VITE_API_BASE_URL));

        if (isOurApi) {
            const maintenanceFrom =
                response.headers['x-maintenance-from'] || response.headers['X-Maintenance-From'];
            const maintenanceTo =
                response.headers['x-maintenance-to'] || response.headers['X-Maintenance-To'];

            if (maintenanceFrom || maintenanceTo) {
                maintenanceService.setMaintenanceWindow(maintenanceFrom, maintenanceTo);
            }
        }

        return response;
    },
    (error) => {
        const isOurApi =
            error.config?.url &&
            (error.config.url.includes('/cpanel/') ||
                error.config.url.includes('/api/') ||
                error.config.url.startsWith('/') ||
                error.config.url.includes(import.meta.env.VITE_API_BASE_URL));

        if (isOurApi && error.response && error.response.status === 503) {
            const maintenanceFrom =
                error.response?.headers?.['x-maintenance-from'] ||
                error.response?.headers?.['X-Maintenance-From'];
            const maintenanceTo =
                error.response?.headers?.['x-maintenance-to'] ||
                error.response?.headers?.['X-Maintenance-To'];

            if (maintenanceFrom || maintenanceTo) {
                maintenanceService.setMaintenanceWindow(maintenanceFrom, maintenanceTo);
            }

            const currentMessage = maintenanceService.isInMaintenance
                ? maintenanceService.maintenanceMessageActive
                : maintenanceService.maintenanceMessage;
            const maintenanceError = new Error(currentMessage);
            maintenanceError.isMaintenance = true;
            maintenanceError.status = 503;
            maintenanceError.originalError = error;

            return Promise.reject(maintenanceError);
        }

        return Promise.reject(error);
    },
);

export const initializeMaintenanceService = () => {
    maintenanceService.startPeriodicCheck();

    if (typeof window !== 'undefined') {
        window.addEventListener('beforeunload', () => {
            maintenanceService.destroy();
        });
    }
};

export { maintenanceService };
export default api;
